<template lang="pug">
.container.mt-4.mt-sm-5.mb-6
    .d-flex.justify-content-between.align-items-center.flex-column.flex-md-row
        h1.mb-3 Protokolle

        .toolbar.d-flex.flex-column.flex-md-row
            form.d-flex.mr-md-5.mb-3(@submit.prevent="page = 1; loadProtocols()")
                input.form-control.mr-2(v-model="search", placeholder="Protokolle durchsuchen ...")
                button.btn.btn-secondary(type="submit") Suchen
            router-link.btn.btn-primary.mb-3(v-if="accountActive", to="/protokolle/erstellen")
                font-awesome-icon(icon="plus")
                span.ml-2 Protokoll erstellen

    .card.shadow-sm
        .list-group(v-if="total")
            .list-group-item(v-for="(protocol, idx) in protocols")
                .protocol
                    span.mr-2(v-if="accountActive")
                        router-link.font-weight-bold(:to="`/protokolle/erstellen?id=${protocol.id}`") {{ protocol.title }}
                        br
                        //- until this PR gets merged, we can't show the name of deleted users: https://github.com/dsanel/mongoose-delete/pull/40/files
                        | erstellt am {{ formatDate(protocol.createdAt) }} von {{ protocol.createdBy ? protocol.createdBy.username : 'Benutzer gelöscht' }}
                    span.mr-2(v-else)
                        strong {{ protocol.title }}
                        br
                        | erstellt am {{ formatDate(protocol.createdAt) }} von {{ protocol.createdBy ? protocol.createdBy.username : 'Benutzer gelöscht' }}
                    .badge.badge-info(v-if="protocol.status == 'open'") ENTWURF
                    .badge.badge-warning(v-if="protocol.status == 'pending'") WARTET AUF FREIGABE
                    .badge.badge-success(v-if="protocol.status == 'closed'") ABGESCHLOSSEN

                .btn-toolbar
                    router-link.btn.btn-sm.btn-secondary.mr-2(
                        v-if="accountActive",
                        :to="`/protokolle/erstellen?id=${protocol.id}`"
                    )
                        font-awesome-icon.mr-2(icon="pen")
                        | Bearbeiten
                    dropdown(label="Aktionen")
                        button.dropdown-item(@click="openPDF(protocol)") PDF öffnen
                        button.dropdown-item(@click="downloadPDF(protocol)") PDF herunterladen
                        button.dropdown-item(@click="copyProtocol(protocol)") Kopieren
                        button.dropdown-item(v-if="userRole !== 'user'", @click="deleteProcotol(protocol)") Löschen

            pagination.justify-content-center.mt-3(:pages="numPages", v-model="page", @input="loadProtocols")

        .list-group(v-else)
            .list-group-item.justify-content-center: em Keine Protokolle gefunden
</template>

<script>
import api from '@/utils/api'
import { downloadPDF, openPDF } from '@/utils/pdf'
import Dropdown from '@/components/Dropdown.vue'
import Pagination from '@/components/Pagination.vue'
import { formatDate } from '@/utils/format'
import { Protocol } from 'trgi'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faFileDownload, faPen } from '@fortawesome/free-solid-svg-icons'

library.add(faPlus, faFileDownload, faPen)

const ITEMS_PER_PAGE = 25

export default {
    components: {
        Dropdown,
        Pagination
    },
    data () {
        return {
            page: 1,
            total: 0,
            search: '',
            protocols: []
        }
    },
    computed: {
        accountActive () {
            return this.$store.getters.accountActive
        },
        numPages () {
            return Math.ceil(this.total / ITEMS_PER_PAGE)
        },
        userRole () {
            return this.$store.getters.userRole
        }
    },
    created () {
        this.loadProtocols(this.page)
    },
    methods: {
        formatDate,
        downloadPDF,
        openPDF,
        async loadProtocols (page) {
            const params = {
                page,
                limit: ITEMS_PER_PAGE,
                search: this.search,
                embed: 'createdBy'
            }
            const { total, protocols } = await api.get('/protocols', { params }).then(res => res.data)

            this.total = total
            this.protocols = protocols
        },
        async copyProtocol (original) {
            const protocol = new Protocol(original)

            // remove fields, that should not be copied
            delete protocol._id
            delete protocol.createdBy
            delete protocol.account
            delete protocol.createdAt
            delete protocol.updateAt

            protocol.status = 'open'
            protocol.title = `Kopie von ${protocol.title}`

            const result = await api.post('/protocols', protocol).then(res => res.data)
            this.$router.push(`/protokolle/erstellen?id=${result.id}`)
        },
        async deleteProcotol (protocol) {
            if (confirm('Sind Sie sich sicher, dass Sie dieses Protokoll unwiderruflich löschen möchten?')) {
                await api.post(`/protocols/${protocol.id}`, { deleted: true, deletedAt: new Date() })
                this.loadProtocols()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.list-group-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .protocol {
        margin-bottom: 0.5rem;
    }

    @include media-breakpoint-up(lg) {
        flex-direction: row;
        align-items: center;

        .protocol {
            margin-bottom: 0;
        }
    }
}
</style>
